<div class="ticker-block-item">
  <span class="ticker-block-item__label html" *ngIf="label" [innerHTML]="label | markdown"></span>
  <div class="ticker-block__image-container" #imageContainer>
    <img
      [src]="imageUrl"
      class="ticker-block-item__image ticker-block-item__image--pre"
      #imagePre
      *ngIf="loopImage" />
    <img
      [src]="imageUrl"
      class="ticker-block-item__image ticker-block-item__image--post"
      #imagePost
      *ngIf="loopImage" />
    <img [src]="imageUrl" class="ticker-block-item__image" #image />
  </div>
</div>
